<div class="setting-main-wrapper">
    <div class="row">
        <div *ngIf="isDbLookUpView" [ngClass]="isGradeMatrixView ? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6' : 'col-xxl-12 col-xl-12 col-lg-12 col-md-12'">
            <div class="div-wrapper lookup-wrapper">
                <div class="lookup-head">
                    <h4>{{ 'SETTING_PAGE.CDMS_SETTINGS.DATABASE_LOOKUP' | transloco }}</h4>
                    <div class="icon-wrapper">
                        <button class="btn primary-ebtn" [disabled]="disableEdit" (click)="saveAllChanges()">
                            <mat-icon class=" " matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.SAVE' | transloco }}">save</mat-icon>
                            <!-- <span class="btn-label">Save</span> -->
                        </button>
                        <button class="btn primary-ebtn" [disabled]="disableCancel" (click)="undoAllChanges()">
                            <mat-icon class=" " matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.RESET' | transloco }}">undo</mat-icon>
                            <!-- <span class="btn-label">Reset</span> -->
                        </button>
                    </div>
                </div>

                <div class="field-wrapper">
                    <dx-tree-list
                        class="tree-list-1"
                        #treeList
                        [dataSource]="data"
                        keyExpr="id"
                        parentIdExpr="parentId"
                        [columnAutoWidth]="true"
                        [wordWrapEnabled]="true"
                        [showBorders]="true"
                        [showColumnHeaders]="false"
                        (onInitNewRow)="onInitNewRow($event)"
                        (onRowInserted)="onRowInserted()"
                        (onRowUpdated)="onRowUpdated()"
                        (onRowRemoved)="onRowRemoved()"
                        (onSaving)="handleSaving($event)"
                        (onOptionChanged)="onDbLookupOptionChanged($event)"
                        (onEditorPreparing)="onEditorPreparing($event)"
                        (onRowClick)="onDbLookupRowClick($event)"
                        (onCellClick)="onDbLookupCellClick($event)"
                        (onRowPrepared)="onDbLookupRowPrepared($event)"
                        (onToolbarPreparing)="customizeToolbar($event)"
                        (onEditingStart)="onDbLookupEditingStart($event)"
                    >
                        <dxo-editing mode="batch" [allowDeleting]="allowDeleting" [allowUpdating]="true" [useIcons]="true">
                        </dxo-editing>
                        <dxi-column dataField="name" [minWidth]="260" cellTemplate="nameTemplate">
                            <dxi-validation-rule
                                type="custom"
                                message="Value cannot be empty"
                                [validationCallback]="validateNonWhitespaceValue"
                            ></dxi-validation-rule>
                            <dxi-validation-rule
                                type="custom"
                                message="Only A-Z, a-z, 0-9, space and . , ! ? ' &quot; - _ ( ) are allowed"
                                [validationCallback]="validateAllowedCharacters"
                            ></dxi-validation-rule>
                            <dxi-validation-rule
                                type="custom"
                                message="Database Value already exisits."
                                [validationCallback]="validateUniqueLookupValue"
                            ></dxi-validation-rule>
                            <dxi-validation-rule
                                type="custom"
                                message="Grade value must be between 1 and 5"
                                [validationCallback]="validateGradeValue"
                            ></dxi-validation-rule>
                        </dxi-column>
                        <dxi-column
                            dataField="code"
                            [minWidth]="120"
                            [visible]="showSecondColumn"
                            [calculateCellValue]="getSharedCodeOrCommentValue"
                            [setCellValue]="setSharedCodeOrCommentValue"
                            cellTemplate="codeTemplate"
                        >
                            <dxi-validation-rule
                                type="custom"
                                message="Only A-Z, a-z, 0-9, space and . , ! ? ' &quot; - _ ( ) are allowed"
                                [validationCallback]="validateAllowedCharacters"
                            ></dxi-validation-rule>
                            <dxi-validation-rule
                                type="custom"
                                message="Country code must be 1 to 5 characters"
                                [validationCallback]="validateCountryCode"
                            ></dxi-validation-rule>
                            <dxi-validation-rule
                                type="custom"
                                message="Country is required"
                                [validationCallback]="validateTrainingVenueCountrySelection"
                            ></dxi-validation-rule>
                        </dxi-column>

                        <dxi-column type="buttons" [width]="90">
                            <dxi-button icon="add" hint="Add" [visible]="allowAdding" [onClick]="onCustomAddClick"></dxi-button>
                            <dxi-button name="delete" [visible]="allowDeleting"></dxi-button>
                        </dxi-column>

                        <div *dxTemplate="let cell of 'nameTemplate'">
                            <span
                                *ngIf="!cell.displayValue && !cell.value && cell.data?.rowType === 'item' && cell.data?.supportsCrud"
                                class="text-muted"
                                style="opacity: 0.7"
                            >
                                {{ getNamePlaceholder(cell.data?.section) }}
                            </span>
                            <span *ngIf="cell.displayValue || cell.value || cell.data?.rowType !== 'item' || !cell.data?.supportsCrud">
                                {{ cell.displayValue || cell.value }}
                            </span>
                        </div>

                        <div *dxTemplate="let cell of 'codeTemplate'">
                            <span
                                *ngIf="
                                    !cell.displayValue &&
                                    !cell.value &&
                                    cell.data?.rowType === 'item' &&
                                    cell.data?.supportsCrud &&
                                    getCodePlaceholder(cell.data)
                                "
                                class="text-muted"
                                style="opacity: 0.7"
                            >
                                {{ getCodePlaceholder(cell.data) }}
                            </span>
                            <span *ngIf="cell.displayValue || cell.value || cell.data?.rowType !== 'item' || !cell.data?.supportsCrud">
                                {{ cell.displayValue || cell.value }}
                            </span>
                        </div>
                    </dx-tree-list>
                </div>
            </div>
        </div>

        <div *ngIf="isGradeMatrixView" [ngClass]="isDbLookUpView ? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6' : 'col-xxl-12 col-xl-12 col-lg-12 col-md-12'">
            <div class="div-wrapper grade-wrapper">
                <div class="lookup-head">
                    <h4>{{ 'SETTING_PAGE.CDMS_SETTINGS.GRADE_MATRIX' | transloco }}</h4>
                    <div class="icon-wrapper">
                        <button class="btn primary-ebtn" [disabled]="disableEditGrade" (click)="saveGradeMatrixChanges()">
                            <mat-icon class=" " matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.SAVE' | transloco }}">save</mat-icon>
                            <!-- <span class="btn-label">{{ 'SETTING_PAGE.IDMS_SETTINGS.SAVE' | transloco }}</span> -->
                        </button>
                        <button class="btn primary-ebtn" [disabled]="disableCancelGrade" (click)="undoGradeMatrixChanges()">
                            <mat-icon class=" " matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.RESET' | transloco }}">undo</mat-icon>
                            <!-- <span class="btn-label">{{ 'SETTING_PAGE.IDMS_SETTINGS.RESET' | transloco }}</span> -->
                        </button>
                    </div>
                </div>

                <div class="field-wrapper">
                    <dx-tree-list
                        #treeListGradeMatrix
                        class="tree-list-1"
                        [dataSource]="gradeMatrixData"
                        keyExpr="id"
                        parentIdExpr="parentId"
                        [columnAutoWidth]="true"
                        [wordWrapEnabled]="true"
                        [showBorders]="true"
                        [showColumnHeaders]="false"
                        [expandedRowKeys]="[1000]"
                        (onInitNewRow)="onInitNewGradeRow($event)"
                        (onRowInserted)="onGradeRowInserted()"
                        (onRowUpdated)="onGradeRowUpdated()"
                        (onRowRemoved)="onGradeRowRemoved()"
                        (onToolbarPreparing)="customizeToolbar($event)"
                        (onEditingStart)="onGradeEditingStart($event)"
                    >
                        <dxo-editing
                            mode="batch"
                            [allowDeleting]="allowDeletingGrade"
                            [allowUpdating]="true"
                            [useIcons]="true"
                        >
                        </dxo-editing>
                        <dxi-column dataField="name" [minWidth]="260" cellTemplate="gradeNameTemplate">
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                            <dxi-validation-rule
                                type="custom"
                                message="Only A-Z, a-z, 0-9, space and . , ! ? ' &quot; - _ ( ) are allowed"
                                [validationCallback]="validateAllowedCharacters"
                            ></dxi-validation-rule>
                        </dxi-column>

                        <dxi-column type="buttons" [width]="90">
                            <dxi-button icon="add" hint="Add" [visible]="allowAddingGrade" [onClick]="onCustomGradeAddClick"></dxi-button>
                            <dxi-button name="delete" [visible]="allowDeletingGrade"></dxi-button>
                        </dxi-column>

                        <div *dxTemplate="let cell of 'gradeNameTemplate'">
                            <span *ngIf="!cell.displayValue && !cell.value" class="text-muted" style="opacity: 0.7"> Enter grade </span>
                            <span *ngIf="cell.displayValue || cell.value">
                                {{ cell.displayValue || cell.value }}
                            </span>
                        </div>
                    </dx-tree-list>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #unsavedChangesModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Unsaved Changes</h4>
    </div>
    <div class="modal-body">There are unsaved changes available. Please save or undo to proceed.</div>
    <div class="modal-footer">
        <button type="button" class="btn secondary-ebtn" (click)="onUnsavedChangesUndo(modal)">Undo</button>
        <button type="button" class="btn primary-ebtn" (click)="onUnsavedChangesSave(modal)">Save</button>
    </div>
</ng-template>
